import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const ScheduleApplicationBulkChangePolicyCommandsList: FC<
    CommandsListProps
> = ({ options = {} }) => {
    const {
        scheduleApplicationsChangePolicySelectedCount = 0,
        scheduleApplicationsChangePolicyOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Change policy for ${pluralizeWithCount("schedule", scheduleApplicationsChangePolicySelectedCount)}`}
            options={scheduleApplicationsChangePolicyOptions}
        />
    );
};
